<template>
  <div>
    <div v-if="!info.takeNo && !info.orderId" class="noOrder">暂无订单</div>
<!--    <div v-if="!info.takeNo && info.orderId" class="noOrder">-->
<!--      <div class="takNo">-->
<!--        <p style="text-align: center;font-size: 19px;font-weight: 600">待支付</p>-->
<!--        <div class="orderBtn">-->
<!--          <el-button type="primary" @click="cancelOrder" style="background-color: #FFFFFF;border-color:#F5F5F5;color: #000000">取消订单</el-button>-->
<!--          <el-button type="primary" @click="toAliUrl" style="background-color: #E60012;border-color:#E60012;">确认支付</el-button>-->
<!--          &lt;!&ndash;              ali跳转之前是payOrder&ndash;&gt;-->
<!--        </div>-->
<!--        &lt;!&ndash;            <p style="text-align: center;font-size: 14px">订单金额已原路返回，请及时查看</p>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
    <div v-else>
      <div class="orderBox">
        <img class="bg" src="../assets/bg.png">
        <img class="xue" src="../assets/order.png">
        <div class="takNo" v-if="info.isRefund != 1 && info.orderStatus !== 10 && !info.cancelType">
          <p>凭取餐码自提：{{ info.takeNo }}</p>
          <p>门店已接单，请于下单当日及时到店取餐</p>
        </div>

        <div v-else-if="info.orderStatus === 10" class="takNo">
          <p style="text-align: center;font-size: 19px;font-weight: 600">待支付</p>
          <div class="orderBtn">
            <el-button type="primary" @click="cancelOrderAD(true)" style="background-color: #FFFFFF;border-color:#F5F5F5;color: #000000">取消订单</el-button>
            <el-button type="primary" @click="toAliUrl" style="background-color: #E60012;border-color:#E60012;">确认支付</el-button>
            <!--              ali跳转之前是payOrder-->
          </div>
          <!--            <p style="text-align: center;font-size: 14px">订单金额已原路返回，请及时查看</p>-->
        </div>

        <div v-else-if="info.cancelType" class="takNo">
          <p style="text-align: center;font-size: 19px;font-weight: 600">订单已取消</p>
          <p style="text-align: center;font-size: 14px">期待您的光临</p>
          <el-button type="primary" @click="cancelOrderAD(false)" style="margin-top: 10px;background-color: #FFFFFF;border-color:#F5F5F5;color: #000000">重新下单</el-button>
        </div>

        <div v-else class="takNo">
          <p>已退单</p>
          <p>订单金额已原路返回，请及时查看</p>
        </div>
      </div>

      <div class="home">
        <div class="shopBox">
          <div class="border_btm">
            <p style="font-size: 18px;">{{ info.shopName }}</p>
            <P class="font_L" style="margin:10px 0;">{{ info.shopAddress }}</P>
          </div>

          <div class="product border_btm">
            <img :src="info.productLogo">
            <!--                <image v-else :src="errImg" mode="aspectFit" style="width: 100px;height: 120px;"></image> -->

            <div class="detail">
              <div class="flex-ad">
                <p>{{ info.productName }}</p>
                <p>￥{{ info.productPrice / 100 }}</p>
              </div>
              <p class="font_L" style="margin: 10px 0 20px 0;">
                {{
                  info.attributeName
                }}</p>
              <div class="flex-ad">
                <p>×{{ info.productAmount }}</p>
              </div>
            </div>
          </div>

          <div class="juanSec border_btm">
            <p class="font_L">优惠券</p>
            <p style="color: #F12734">-￥{{ info.productPrice / 100 }}</p>
          </div>

          <div class="btm">
            <p style="text-align: right;font-size: 13px">共1件，合计<span
                style="font-size: 15px;font-weight: bold">￥{{ info.realPrice / 100 }}</span></p>
          </div>

        </div>

        <div class="shopBox" style="margin-top: 30px">
          <div class="item">
            <p>下单时间</p>
            <p class="right">{{ info.orderTime }}</p>
          </div>
          <div class="item">
            <p>订单编号</p>
            <p class="right">{{ info.orderId }}</p>
          </div>

          <div class="item">
            <p>取餐号码</p>
            <p class="right">{{ info.takeNo }}</p>
          </div>
          <div class="item">
            <p>是否打包</p>
            <p class="right">要打包袋</p>
          </div>
          <div class="item">
            <p>备注</p>
            <p class="right">{{ !info.remark ? '无' : info.remark }}</p>
          </div>
          <div class="item">
            <p>门店编码</p>
            <p class="right">{{ info.shopCode }}</p>
          </div>
          <div class="item">
            <p>手机号</p>
            <p class="right">{{ info.mobilePhone }}</p>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {cancelOrder,getAliUrl,queryOrder} from "@/api/mxbc";
import {samira}from "@/utils/kalista"

export default {
  name: 'orderInfo',
  data() {
    return {
      info: {},
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.query.cardID) {
          this.cardID = this.$route.query.cardID
          localStorage.setItem('cardID', this.cardID);
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route.query.cardID) {
      this.cardID = this.$route.query.cardID
      localStorage.setItem('cardID', this.cardID);
    }
    if (!localStorage.getItem('cardID')) return this.$message.error('未复制完整卡密链接')
    this.getOrder();
  },
  methods: {
    getOrder() {
      queryOrder({cardID: localStorage.getItem('cardID')}).then(res => {
        if (res.code !== 0) return
        this.info = res.data
        //console.log(res, '订单查询返回')
      }).catch(err=>{
        this.$message.error('查询失败,请刷新重试')
      })
    },
    cancelOrderAD(flag){
      cancelOrder({cardID: localStorage.getItem('cardID'),orderCode:this.info.orderId,flag}).then(res => {
        if (res.code === 0){
          this.$message.success(res.msg)
          location.reload();
        }
      }).catch(err=>{
        this.$message.error('查询失败,请刷新重试')
      })
    },
    toAliUrl(){
      getAliUrl({cardID:localStorage.getItem('cardID')}).then(res => {
        if (res.code === 0){
          let url = samira(res.data);
          console.log(url)
          window.location.href=url
        }else{
          this.$message.error(res.msg)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: calc(100vh);
  padding-top: 10px;
  background-color: #F5F5F5;
  margin: -10px 0 0 0;
  border-radius: 10px 10px 0 0;
  position: relative;
}

.orderBox {
  width: 100%;
  height: 170px;
  position: relative;

  .bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .xue {
    width: 33vw;
    max-width: 140px;
    min-width: 60px;
    height: auto;
    aspect-ratio: 1.17;
    object-fit: contain;
    position: absolute;
    right: 5vw;
    bottom: 0;
    z-index: 1;
  }

  .takNo {
    position: absolute;
    left: 5vw;
    bottom: 40px;
    color: #FFFFFF;
    max-width: 55vw;
    z-index: 2;
    p:first-child {
      font-size: 1.2rem;
      font-weight: bold;
      margin-bottom: 10px;
      line-height: 1.2;
      word-break: break-all;
    }
    p:last-child {
      font-size: 0.85rem;
      line-height: 1.2;
      word-break: break-all;
    }
  }
}


.shopBox {
  width: 85%;
  margin: 0 auto;
  padding: 15px;
  background-color: #FFFFFF;
  border-radius: 10px;
  //z-index: 666;
  //height: 300px;
}

.product {
  padding: 10px 0;
  display: flex;
  flex-direction: row;

  img {
    width: 110px;
    height: 100px;
    margin-right: 15px;
    object-fit: cover;
  }

  .detail {
    width: calc(100% - 100px);
  }

}

.payInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.juanSec {
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.flex-ad {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btm {
  margin-top: 20px;
}


.item {
  display: flex;
  margin: 15px 0;
}

.item p:first-child{
  min-width: 80px;
  margin-right: 10px;
  color: #999999;
}

.right {
  color: #606060;
}



.juan {
  font-size: 14px;
  border: 1px solid #842A43;
  color: #842A43;
  padding: 3px 5px;
}


.font_L {
  font-size: 13px;
  color: #999999;
}

.border_btm {
  border-bottom: 1px dashed #999999;
}

.noOrder{
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>